module.exports = __webpack_public_path__ + "static/media/img12.b15dac31.jpg";